//@ts-nocheck
import clsx from "clsx";
import React from "react";
import { AccordionProps } from "../@types/accordion";
import {isEqual} from "../../../lib/utils";

function Accordion(props: AccordionProps) {
  const { id = "accordion", children, className } = props;

  let childrenToArray = children;
  if (!Array.isArray(children)) {
    childrenToArray = [children];
  }
  return (
    <div className={clsx("accordion", className)} id={id}>
      {childrenToArray &&
        childrenToArray.length &&
        childrenToArray?.map((item, index) => {
          return (
            <div key={index} className="accordion-item">
              <h2 className="accordion-header" id={`heading${index}`}>
                <button
                  type="button"
                  aria-expanded="true"
                  data-bs-toggle="collapse"
                  aria-controls={`collapse${index}`}
                  data-bs-target={`#collapse${index}`}
                  className={clsx(
                    "accordion-button",
                    !isEqual(index ,0) ? "collapsed" : ""
                  )}
                >
                  {item?.props?.children && item?.props?.children[0]}
                </button>
              </h2>
              <div
                id={`collapse${index}`}
                className={clsx(
                  "accordion-collapse ",
                  isEqual(index ,0) ? "collapse show" : "collapse"
                )}
                data-bs-parent={`#${id}`}
                aria-labelledby={`heading${index}`}
              >
                <div className="accordion-body">
                  {item?.props?.children && item?.props?.children[1]}
                </div>
              </div>
            </div>
          );
        })}
    </div>
  );
}

export default Accordion;
